import { ref, computed } from "vue";
import { useI18n } from "vue3-i18n";
import { useToast } from "vue-toast-notification";
import { useBillingStore } from "@/stores/billing";
import type { UserAccountDetails } from "@/types/account";

export function useUpgradePlanBillingLink(
  userData?: globalThis.Ref<UserAccountDetails | null>
) {
  const i18n = useI18n();
  const $toast = useToast();
  const billingStore = useBillingStore();
  const billingUpgradeConfirmed = ref(false);
  const router = useRouter();

  const {
    data: link,
    isFetching,
    isRefetching,
    isError,
    error,
    isStale,
    refetch,
  } = useBillingLink(userData);

  const goToBillingUi = async () => {
    if (isStale.value || !link.value) {
      await refetch();
    }

    if (isError.value || !link.value) {
      billingUpgradeConfirmed.value = false;
      $toast.error(
        error.value?.message || i18n.t("errors.tryAgain"),
        defaultToastOptions
      );
      return;
    }

    visitWebsite(link.value);
  };

  const handleBillingUpgradeConfirmation = () => {
    if (billingStore.isNonStripeFreeTrialActive) {
      router.push({ name: RouteNames.PLANS });
      return;
    }

    if (!billingUpgradeConfirmed.value) {
      billingUpgradeConfirmed.value = true;
      goToBillingUi();
    }
    return null;
  };

  return {
    link,
    isFetching,
    isRefetching,
    isError,
    error,
    isStale,
    billingUpgradeConfirmed: computed(() => billingUpgradeConfirmed.value),
    goToBillingUi,
    handleBillingUpgradeConfirmation,
  };
}
